import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { useNavigate } from 'react-router-dom'

import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined'
import VisibilityIcon from '@mui/icons-material/Visibility'

import { theme } from '../../themes/theme'
import { editorPath, viewerPath } from './redactionEditor/paths'
import { SecondaryIconButton } from '../common/Button'

const EditRedactionsButton = styled(SecondaryIconButton)`
  .MuiSvgIcon-root {
    color: ${theme.colors.primary};
  }
`

function OpenRedactionFileButton({ file, foiId, disabled = false, viewOnly = false }) {
  const navigate = useNavigate()
  const isNoted = file.status === 'REDACTIONS_NOTED' && !viewOnly
  const label = isNoted ? 'Edit redactions' : 'View'
  const target = isNoted ? editorPath(foiId, file.associationId) : viewerPath(foiId, file.associationId, file.id)
  const IconButtonForStage = isNoted ? EditRedactionsButton : SecondaryIconButton

  return (
    <IconButtonForStage onClick={() => navigate(target)} aria-label={label} title={label} disabled={disabled}>
      {isNoted ? <BorderColorOutlinedIcon /> : <VisibilityIcon />}
    </IconButtonForStage>
  )
}

OpenRedactionFileButton.propTypes = {
  file: PropTypes.object.isRequired,
  foiId: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  viewOnly: PropTypes.bool
}

export default OpenRedactionFileButton
